import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { Document, ICustomAttribute } from '../../../../interfaces/graph-types';
import { AccountService } from '../../../../services/account.service';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { ModalCreateCandidateAttributeComponent } from '../../../modals/create-candidate-attribute/modal-create-candidate-attribute.component';
import * as gql from './account-candidate-attributes.component.graphql';

@Component({
  selector: '[account-candidate-attributes]',
  template: require('./account-candidate-attributes.component.pug'),
  styles: [require('./account-candidate-attributes.component.css').toString()],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountCandidateAttributeComponent {
  public readonly emptyImage = require('./empty.png').default;

  public attributes$: Observable<ReadonlyArray<ICustomAttribute>>;

  private readonly candidateAttributesQueryRef = this.apollo.watchQuery<
    gql.CandidateAttributesQuery,
    gql.CandidateAttributesQueryVariables
  >({
    query: gql.candidateAttributesQuery(),
  });

  // -------------------------------------------------------------------
  public constructor(
    private readonly apollo: Apollo,
    private readonly modalService: BsModalService,
    private readonly accountService: AccountService,
    private readonly watch: WatchAccountService,
  ) {
    this.attributes$ = this.watch.accountId().pipe(
      tap(accountId =>
        this.candidateAttributesQueryRef.setVariables({ accountId }),
      ),
      switchMap(() => this.candidateAttributesQueryRef.valueChanges),
      filter(({ data }) => !!data),
      map(({ data }) => data.account.candidateAttributes),
    );
  }

  // -------------------------------------------------------------------
  public get emptyImageCss(): string {
    return `url(${this.emptyImage})`;
  }

  // -------------------------------------------------------------------
  public trackByDocumentId(index: number, doc: Document): Document['id'] {
    return doc.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  public openCreateAttributeModal(): void {
    const modalRef = this.modalService.show(
      ModalCreateCandidateAttributeComponent,
      {
        class: 'gray modal-lg',
      },
    );

    const modal: ModalCreateCandidateAttributeComponent = modalRef.content;

    modal.attributeCreated.subscribe(() =>
      this.candidateAttributesQueryRef.refetch(),
    );
  }

  // -------------------------------------------------------------------
  public delete(data: ICustomAttribute, _, onFailure: onSmartFailure): void {
    this.accountService.deleteCandidateAttribute(
      this.watch.accountId().getValue(),
      data.id,
      () => this.candidateAttributesQueryRef.refetch(),
      error => onFailure(error),
    );
  }
}
